import { chain } from "lodash";
import { communes, regions, provinces } from "@mekidoc/utils";

export const regionsWithCommunes = regions.map((region) => ({
  ...region,
  communes: chain(provinces)
    .filter((province) => province.codigo_padre === region.codigo)
    .flatMap((province) =>
      communes.filter((commune) => commune.codigo_padre === province.codigo),
    )
    .sortBy("nombre")
    .value(),
}));
